import { BottomNavigation, BottomNavigationAction, Box, Hidden, Icon, Menu, MenuItem, styled } from "@mui/material";
import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { BrandEnum } from "../_common/enum/brand.enum";
import AppSidebar from "../_components/sidebar/app.sidebar";
import { AppToolbar } from "../_components/toolbar/app.toolbar";
import { ADMIN_NAV, PRIMARY_NAV, USER_NAV } from "../_const/navigation.const";
import { accountService } from "../_services/accounts.service";


const drawerWidth = 240;

const useStyles = {

    appScreen: {
        display: 'flex',
        backgroundColor: "#e6e6e6",
        height: "100%"
    },
    main: {
        marginTop: "40px"
    },
    root: {

    },
    mainBackground: {},
    stickToBottom: {
        width: '100%',
        position: 'fixed',
        bottom: 0,
        borderTop: '1px solid #e6e6e6',
        zIndex: 9999
    },
    toolbar: {},
};

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    width: 'calc(100% - 500px)',
    maxWidth: "calc(100%)",
    paddingTop: theme.spacing(10),
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));


export function AppScreen(params: {brand: BrandEnum}) {
    const [value, setValue] = React.useState(0);
    const [isOpen, setIsOpen] = useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const goTo = useNavigate();
    const [selectedListItem, setSelectedListItem] = useState(null);


    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any, nav: any) => {
        setAnchorEl(null);
        if (nav && nav.url)
            goTo(nav.url);
    };

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    }

    const handleSelectedItemClick = (item: any) => {
        setSelectedListItem(item);
    };


    return (
        <div style={useStyles.appScreen} id="app-screen">

            <AppToolbar toggleSidebar={toggleSidebar} brand={params.brand} />

            <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}>
                <AppSidebar isOpen={isOpen} />
            </Box>

            <Main open={isOpen}>
                <Box sx={{ p: { xs: 1, md: 4 } }}>
                    <Outlet></Outlet>
                </Box>
            </Main>

            <Hidden mdUp>
                <BottomNavigation
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    showLabels={true}
                    sx={{
                        width: '100%',
                        position: 'fixed',
                        bottom: 0,
                        borderTop: '1px solid #e6e6e6',
                    }}>

                    {PRIMARY_NAV && PRIMARY_NAV.map(nav =>
                        <BottomNavigationAction key={"bottomNav_" + nav.name} onClick={() => goTo(nav.url)} label={nav.mobileName || nav.name} icon={
                            <>
                                {nav.png == null &&
                                    <Icon>{nav.icon}</Icon>
                                }
                            </>
                        } />
                    )}

                    {accountService.isAdmin &&
                        <BottomNavigationAction label={'Admin'} aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} icon={
                            <Icon>apps</Icon>
                        } />
                    }

                    {accountService.isAdmin &&
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >

                            {ADMIN_NAV && ADMIN_NAV.map(nav =>
                                <MenuItem
                                    sx={selectedListItem === nav ? {
                                        backgroundColor: '#bbc0f6 !important',
                                        color: 'black !important',
                                        borderLeft: '1px solid #fff',
                                    } : {
                                        backgroundColor: 'auto',
                                        color: 'auto',
                                        borderLeft: 'auto',
                                    }}
                                    key={"sideNav_" + nav.name}
                                    onClick={(e: any) => { handleClose(e, nav); handleSelectedItemClick(nav) }}>
                                    {nav.name}
                                </MenuItem>
                            )}

                        </Menu>
                    }

                    {USER_NAV && USER_NAV.map((nav: any) =>
                        <BottomNavigationAction key={"bottomNav_" + nav.name} onClick={nav.onClick} label={nav.mobileName || nav.name} icon={
                            <>
                                {nav.png == null &&
                                    <Icon>{nav.icon}</Icon>
                                }
                            </>
                        } />
                    )}

                </BottomNavigation>
            </Hidden>

        </div >
    );
}